// Form-schema predicate evaluation — the ONE implementation of
// "is this field shown / does this predicate hold?" shared by every surface
// that reads a FormSchema:
//   - the portal SchemaForm renderer (which fields to show/hide),
//   - the portal pre-flight + save validation (QuoteEdit),
//   - the authoritative backend price-side gate (services/pricing).
//
// Keeping this here (not in the portal) is what lets the SPA and the Portal API
// "never disagree" about visibility — the same rule the ship-to / order-services
// gates follow (see vocabulary.ts). DO NOT fork this logic into a component;
// import it.
// ── predicate evaluation ─────────────────────────────────────────────
// Returns true when the predicate is satisfied OR when the predicate is
// null/undefined (the field has no conditional gating). Evaluates the
// conditional_show / hide_when / disable_when / applies_when vocabulary from
// v2_FORM_SCHEMA_FORMAT.md §Conditional visibility.
export function evalExpr(expr, values) {
    if (expr == null)
        return true;
    if (typeof expr !== 'object')
        return true;
    const e = expr;
    // Boolean combinators
    if (Array.isArray(e.all)) {
        return e.all.every((p) => evalExpr(p, values));
    }
    if (Array.isArray(e.any)) {
        return e.any.some((p) => evalExpr(p, values));
    }
    if (e.not !== undefined) {
        return !evalExpr(e.not, values);
    }
    // Leaf predicate: { field: "x", <operator>: <operand> }
    if (typeof e.field === 'string') {
        const v = values[e.field];
        if ('equals' in e)
            return v === e.equals;
        if ('not_equals' in e)
            return v !== e.not_equals;
        if (Array.isArray(e.in))
            return e.in.includes(v);
        if (Array.isArray(e.not_in))
            return !e.not_in.includes(v);
        // Array-contains: the field's value is an array (e.g. the `finishing`
        // multi_enum) and we test whether it CONTAINS the operand. Distinct from
        // `in` (which tests a scalar field value against a list).
        if ('includes' in e)
            return Array.isArray(v) && v.includes(e.includes);
        if (typeof e.gt === 'number')
            return typeof v === 'number' && v > e.gt;
        if (typeof e.gte === 'number')
            return typeof v === 'number' && v >= e.gte;
        if (typeof e.lt === 'number')
            return typeof v === 'number' && v < e.lt;
        if (typeof e.lte === 'number')
            return typeof v === 'number' && v <= e.lte;
        if (e.is_set === true)
            return v !== undefined && v !== null && v !== '';
        if (e.is_empty === true)
            return v === undefined || v === null || v === '';
    }
    return true;
}
//# sourceMappingURL=form-predicate.js.map